// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables */
:root {
  --primary: #6366f1;
  --primary-dark: #4f46e5;
  --primary-light: #818cf8;
  --secondary: #ec4899;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
  --dark: #1e293b;
  --dark-light: #334155;
  --light: #f8fafc;
  --text-primary: #0f172a;
  --text-secondary: #64748b;
  --border: #e2e8f0;
  --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: var(--text-primary);
  overflow-x: hidden;
  line-height: 1.6;
  min-height: 100vh;
}

/* App Wrapper - Simplified */
.app-wrapper {
  padding: 2rem;
  min-height: 100vh;
}

.container {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 2rem;
  max-width: 1600px;
  margin: 0 auto;
  height: calc(100vh - 4rem);
}

/* Sidebar - Optimized */
.sidebar {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2rem;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  will-change: transform;
}

.sidebar-header {
  margin-bottom: 2.5rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.logo-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.3);
}

.sidebar h1 {
  font-size: 1.75rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
}

.tagline {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 400;
  margin-left: 64px;
}

.section-label {
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}

.projects-list {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.project-item {
  padding: 1rem;
  background: var(--light);
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-primary);
}

.project-item:hover {
  border-color: var(--primary-light);
  background: white;
  transform: translateX(4px);
}

.project-item.active {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.project-item span {
  flex: 1;
  font-weight: 500;
}

.delete-project {
  background: var(--danger);
  border: none;
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.delete-project:hover {
  background: #dc2626;
}

/* Main Content - Optimized */
.main-content {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.content-wrapper {
  padding: 2.5rem;
  height: 100%;
  overflow-y: auto;
}

.todo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid var(--border);
}

.header-left h2 {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
  letter-spacing: -1px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-subtitle {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 400;
}

/* Buttons - Simplified */
.btn {
  padding: 0.875rem 1.75rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: inherit;
}

.btn-icon {
  font-size: 1.25rem;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-secondary {
  background: var(--light);
  color: var(--text-secondary);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background: white;
  border-color: var(--primary);
  color: var(--primary);
}

.btn-floating {
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.btn-add-project {
  width: 100%;
  justify-content: center;
  background: var(--light);
  color: var(--primary);
  border: 2px dashed var(--border);
}

.btn-add-project:hover {
  background: white;
  border-color: var(--primary);
}

/* Todo Items - Performance Optimized */
.todos-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.todo-item {
  background: white;
  padding: 1.75rem;
  border-radius: 16px;
  box-shadow: var(--shadow);
  border-left: 4px solid var(--primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  will-change: transform;
}

.todo-item.priority-low {
  border-left-color: var(--success);
}

.todo-item.priority-medium {
  border-left-color: var(--warning);
}

.todo-item.priority-high {
  border-left-color: var(--danger);
}

.todo-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.todo-item.completed {
  opacity: 0.6;
  background: var(--light);
}

.todo-item.completed .todo-title {
  text-decoration: line-through;
  color: var(--text-secondary);
}

.todo-info {
  flex: 1;
}

.todo-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-primary);
  line-height: 1.4;
}

.todo-meta {
  display: flex;
  gap: 1.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.todo-meta span {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.todo-actions {
  display: flex;
  gap: 0.5rem;
}

.todo-actions button {
  padding: 0.625rem 1.125rem;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  font-family: inherit;
}

.view-btn {
  background: var(--primary);
  color: white;
}

.view-btn:hover {
  background: var(--primary-dark);
}

.complete-btn {
  background: var(--success);
  color: white;
}

.complete-btn:hover {
  background: #059669;
}

.delete-btn {
  background: var(--danger);
  color: white;
}

.delete-btn:hover {
  background: #dc2626;
}

/* Modal - Simplified */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.modal.show {
  display: block;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 600px;
}

.modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.modal-header h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.close {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  cursor: pointer;
  color: var(--text-secondary);
  border-radius: 10px;
  transition: all 0.2s ease;
  background: transparent;
}

.close:hover {
  background: var(--light);
  color: var(--text-primary);
}

.modal-content form {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.modal-content input,
.modal-content textarea,
.modal-content select {
  padding: 0.875rem 1rem;
  border: 2px solid var(--border);
  border-radius: 12px;
  font-size: 0.9375rem;
  font-family: inherit;
  transition: border-color 0.2s ease;
  background: white;
}

.modal-content input:focus,
.modal-content textarea:focus,
.modal-content select:focus {
  outline: none;
  border-color: var(--primary);
}

.modal-content textarea {
  resize: vertical;
  min-height: 80px;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.form-actions button {
  flex: 1;
}

.hidden {
  display: none !important;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-state p {
  font-size: 1.125rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.5);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .sidebar {
    height: auto;
  }

  .main-content {
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .app-wrapper {
    padding: 1rem;
  }

  .container {
    height: auto;
  }

  .todo-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .todo-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .todo-actions {
    width: 100%;
  }

  .todo-actions button {
    flex: 1;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}

/* Remove background animation elements if they exist */
.background-animation,
.gradient-orb {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB;sCACoC;EACpC;sCACoC;AACtC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;cACY;EACZ,6DAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qEAAqE;EACrE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qEAAqE;EACrE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qEAAqE;EACrE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wEAAwE;EACxE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;wCACsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uDAAuD;AACvD;;EAEE,aAAa;AACf","sourcesContent":["/* CSS Variables */\r\n:root {\r\n  --primary: #6366f1;\r\n  --primary-dark: #4f46e5;\r\n  --primary-light: #818cf8;\r\n  --secondary: #ec4899;\r\n  --success: #10b981;\r\n  --warning: #f59e0b;\r\n  --danger: #ef4444;\r\n  --dark: #1e293b;\r\n  --dark-light: #334155;\r\n  --light: #f8fafc;\r\n  --text-primary: #0f172a;\r\n  --text-secondary: #64748b;\r\n  --border: #e2e8f0;\r\n  --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\r\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\r\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',\r\n    sans-serif;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: var(--text-primary);\r\n  overflow-x: hidden;\r\n  line-height: 1.6;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* App Wrapper - Simplified */\r\n.app-wrapper {\r\n  padding: 2rem;\r\n  min-height: 100vh;\r\n}\r\n\r\n.container {\r\n  display: grid;\r\n  grid-template-columns: 320px 1fr;\r\n  gap: 2rem;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  height: calc(100vh - 4rem);\r\n}\r\n\r\n/* Sidebar - Optimized */\r\n.sidebar {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 20px;\r\n  padding: 2rem;\r\n  overflow-y: auto;\r\n  box-shadow: var(--shadow-lg);\r\n  will-change: transform;\r\n}\r\n\r\n.sidebar-header {\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.logo-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  color: white;\r\n  font-weight: bold;\r\n  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n.sidebar h1 {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.tagline {\r\n  color: var(--text-secondary);\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  margin-left: 64px;\r\n}\r\n\r\n.section-label {\r\n  color: var(--text-secondary);\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.projects-list {\r\n  margin-bottom: 1.5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.project-item {\r\n  padding: 1rem;\r\n  background: var(--light);\r\n  border: 2px solid transparent;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.project-item:hover {\r\n  border-color: var(--primary-light);\r\n  background: white;\r\n  transform: translateX(4px);\r\n}\r\n\r\n.project-item.active {\r\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\r\n  color: white;\r\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n.project-item span {\r\n  flex: 1;\r\n  font-weight: 500;\r\n}\r\n\r\n.delete-project {\r\n  background: var(--danger);\r\n  border: none;\r\n  color: white;\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.delete-project:hover {\r\n  background: #dc2626;\r\n}\r\n\r\n/* Main Content - Optimized */\r\n.main-content {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 20px;\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.content-wrapper {\r\n  padding: 2.5rem;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.todo-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2.5rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 2px solid var(--border);\r\n}\r\n\r\n.header-left h2 {\r\n  font-size: 2.5rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.25rem;\r\n  letter-spacing: -1px;\r\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.header-subtitle {\r\n  color: var(--text-secondary);\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n}\r\n\r\n/* Buttons - Simplified */\r\n.btn {\r\n  padding: 0.875rem 1.75rem;\r\n  border: none;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-family: inherit;\r\n}\r\n\r\n.btn-icon {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.btn-primary {\r\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\r\n  color: white;\r\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n.btn-primary:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);\r\n}\r\n\r\n.btn-primary:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn-secondary {\r\n  background: var(--light);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: white;\r\n  border-color: var(--primary);\r\n  color: var(--primary);\r\n}\r\n\r\n.btn-floating {\r\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);\r\n}\r\n\r\n.btn-add-project {\r\n  width: 100%;\r\n  justify-content: center;\r\n  background: var(--light);\r\n  color: var(--primary);\r\n  border: 2px dashed var(--border);\r\n}\r\n\r\n.btn-add-project:hover {\r\n  background: white;\r\n  border-color: var(--primary);\r\n}\r\n\r\n/* Todo Items - Performance Optimized */\r\n.todos-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.todo-item {\r\n  background: white;\r\n  padding: 1.75rem;\r\n  border-radius: 16px;\r\n  box-shadow: var(--shadow);\r\n  border-left: 4px solid var(--primary);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: all 0.2s ease;\r\n  will-change: transform;\r\n}\r\n\r\n.todo-item.priority-low {\r\n  border-left-color: var(--success);\r\n}\r\n\r\n.todo-item.priority-medium {\r\n  border-left-color: var(--warning);\r\n}\r\n\r\n.todo-item.priority-high {\r\n  border-left-color: var(--danger);\r\n}\r\n\r\n.todo-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.todo-item.completed {\r\n  opacity: 0.6;\r\n  background: var(--light);\r\n}\r\n\r\n.todo-item.completed .todo-title {\r\n  text-decoration: line-through;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.todo-info {\r\n  flex: 1;\r\n}\r\n\r\n.todo-title {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.75rem;\r\n  color: var(--text-primary);\r\n  line-height: 1.4;\r\n}\r\n\r\n.todo-meta {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  font-size: 0.875rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.todo-meta span {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n}\r\n\r\n.todo-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.todo-actions button {\r\n  padding: 0.625rem 1.125rem;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  font-family: inherit;\r\n}\r\n\r\n.view-btn {\r\n  background: var(--primary);\r\n  color: white;\r\n}\r\n\r\n.view-btn:hover {\r\n  background: var(--primary-dark);\r\n}\r\n\r\n.complete-btn {\r\n  background: var(--success);\r\n  color: white;\r\n}\r\n\r\n.complete-btn:hover {\r\n  background: #059669;\r\n}\r\n\r\n.delete-btn {\r\n  background: var(--danger);\r\n  color: white;\r\n}\r\n\r\n.delete-btn:hover {\r\n  background: #dc2626;\r\n}\r\n\r\n/* Modal - Simplified */\r\n.modal {\r\n  display: none;\r\n  position: fixed;\r\n  z-index: 1000;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.modal.show {\r\n  display: block;\r\n}\r\n\r\n.modal-backdrop {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.modal-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 90%;\r\n  max-width: 600px;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 20px;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\r\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 2rem 2rem 1.5rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.modal-header h3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.close {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  border-radius: 10px;\r\n  transition: all 0.2s ease;\r\n  background: transparent;\r\n}\r\n\r\n.close:hover {\r\n  background: var(--light);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-content form {\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.form-group label {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1rem;\r\n}\r\n\r\n.modal-content input,\r\n.modal-content textarea,\r\n.modal-content select {\r\n  padding: 0.875rem 1rem;\r\n  border: 2px solid var(--border);\r\n  border-radius: 12px;\r\n  font-size: 0.9375rem;\r\n  font-family: inherit;\r\n  transition: border-color 0.2s ease;\r\n  background: white;\r\n}\r\n\r\n.modal-content input:focus,\r\n.modal-content textarea:focus,\r\n.modal-content select:focus {\r\n  outline: none;\r\n  border-color: var(--primary);\r\n}\r\n\r\n.modal-content textarea {\r\n  resize: vertical;\r\n  min-height: 80px;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.form-actions button {\r\n  flex: 1;\r\n}\r\n\r\n.hidden {\r\n  display: none !important;\r\n}\r\n\r\n/* Empty State */\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 4rem 2rem;\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 1.125rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Scrollbar Styling */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: rgba(148, 163, 184, 0.3);\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(148, 163, 184, 0.5);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1024px) {\r\n  .container {\r\n    grid-template-columns: 1fr;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .sidebar {\r\n    height: auto;\r\n  }\r\n\r\n  .main-content {\r\n    min-height: 500px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-wrapper {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .container {\r\n    height: auto;\r\n  }\r\n\r\n  .todo-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .todo-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .todo-actions {\r\n    width: 100%;\r\n  }\r\n\r\n  .todo-actions button {\r\n    flex: 1;\r\n  }\r\n\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* Remove background animation elements if they exist */\r\n.background-animation,\r\n.gradient-orb {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
